import { assign, find } from 'lodash-es';
import { UPDATE_SHIPMENT_SUCCEEDED, FETCH_SHIPMENT_DETAIL_SUCCESSED } from './edit.actions';

export const edit = (state = { fetched: false, data: {}, payment_refund_pendings: [] }, action) => {
  switch (action.type) {
    case UPDATE_SHIPMENT_SUCCEEDED:
      return assign({}, state, { updated: true });
    case FETCH_SHIPMENT_DETAIL_SUCCESSED:
      // if (action.data.order_products.length > 0) {
      //   action.data.order_products.map((i) => {
      //     if (i.product) {
      //       const payment = find(action.payment_refund_pendings, (payment) => payment.data === i.product.sku);
      //       if (payment) {
      //         i.payment = payment;
      //       }
      //     }
      //     return i;
      //   });
      // }
      return assign({}, state, { fetched: true, data: action.data, payment_refund_pendings: action.payment_refund_pendings });

    default:
      return state;
  }
};
